module.exports = __webpack_public_path__ + "static/media/ahmed.3aaa6ac5.png";